import {APPLICATION_TITLE_SUFFIX} from "config/ui";

export const setTitle = title =>
    (document.title = `${title}${
        title && APPLICATION_TITLE_SUFFIX && " | "
    }${APPLICATION_TITLE_SUFFIX}`);
